module.exports = __webpack_public_path__ + "static/media/Sketch1_color.3ac68968.jpg";